import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

export const ButtonStyle = () => ({
  whiteSpace: 'nowrap',
  '&.Mui-disabled': {
    border: 'none'
  }
});

export const ButtonStyled = styled(Button)(ButtonStyle);
